import { useMemo } from 'react';

import { ModuleType } from '@audacy-clients/client-services';
import { useModuleContext } from '@audacy-clients/core/components/ModuleRenderer/context';
import type { IModuleProps } from '@audacy-clients/core/components/ModuleRenderer/types';

import BannerAd from '~/components/BannerAd';
import Grid from '~/components/Grid';
import GridItem from '~/components/Grid/GridItem';
import LiveNow from '~/components/LiveNow';
import ModuleBannerAdWrapper from '~/components/ModuleRenderer/ModuleBannerAdWrapper';
import PreviousEpisode from '~/components/PreviousEpisode';

const ModuleShowLiveNowAndPreviousEpisode: React.FC<IModuleProps> = (props) => {
  const viewInfo = useModuleContext();

  const moduleConfig = useMemo(
    () => ({
      // change id if a specific id is required
      moduleId: props?.module?.id?.replace(ModuleType.SHOW_LIVE_NOW_AND_PREV, ModuleType.BANNER_AD),
      contentId: viewInfo.viewRootObjectId,
    }),
    [props?.module?.id, viewInfo],
  );

  return (
    <>
      <LiveNow isStation={false} {...props} />
      <ModuleBannerAdWrapper {...moduleConfig}>
        <BannerAd />
      </ModuleBannerAdWrapper>
      <Grid>
        <GridItem lg="1/7">
          <PreviousEpisode {...props} />
        </GridItem>
      </Grid>
    </>
  );
};

export default ModuleShowLiveNowAndPreviousEpisode;
